package com.tixforgigs.mandarin

import kotlinx.css.Color
import kotlinx.css.px


// color
object MandarinColors {
  // color: the base light grey
  val colorBaseGreyLight = Color("#CCCCCC")
  // color: the base medium grey
  val colorBaseGreyMedium = Color("#888888")
  // color: the base dark grey
  val colorBaseGreyDark = Color("#363636")
  // color: the base grey
  val colorBaseGreyDarker = Color("#242424")
  // color: the base grey
  val colorBaseGreyDarkest = Color("#111111")
  // color: the base white
  val colorBaseWhite = Color("#FFFFFF")
  // color: the base black
  val colorBaseBlack = Color("#000000")
  // color: the base light orange
  val colorBaseOrangeLight = Color("#FF9911")
  // color: the base pale orange
  val colorBaseOrangePale = Color("#FFECD2")
  // color: the base medium orange
  val colorBaseOrangeMedium = Color("#FF6200")
  // color: the base dark orange
  val colorBaseOrangeDark = Color("#FF4D00")
  // color: the base darker orange
  val colorBaseOrangeDarker = Color("#704000")
  // color: the base darkest orange
  val colorBaseOrangeDarkest = Color("#BB3A02")
  // color: the base light blue
  val colorBaseBlueLight = Color("#00D9FF")
  // color: the base dark blue
  val colorBaseBlueMedium = Color("#003AA6")
  // color: the base dark blue
  val colorBaseBlueDark = Color("#575A7A")
  // color: the base light green
  val colorBaseGreenLight = Color("#00F836")
  // color: the base dark green
  val colorBaseGreenDark = Color("#31F804")
  // color: the base yellow green
  val colorBaseYellowGreen = Color("#E5CD0C")
  // color: the base dark yellow
  val colorBaseYellowDark = Color("#E5CD0C")
  // color: the base red
  val colorBaseRed = Color("#73022E")
  // color: the base rose
  val colorBaseRose = Color("#E3B3F6")
  // color: the base rose
  val colorBasePink = Color("#9B02BE")
  // color: the base rose
  val colorBasePurple = Color("#4C00AB")
  // color: the base bg
  val colorBackgroundBase = Color("#242424")
  // color: the base fg
  val colorForegroundBase = Color("#CCCCCC")
  // color: the light 01
  val colorIconJanuaryLight = Color("#1A82FF")
  // color: the dark 01
  val colorIconJanuaryDark = Color("#161466")
  // color: the gradient start 01
  val colorIconJanuaryGradientStart = Color("#257FF5")
  // color: the gradient end 01
  val colorIconJanuaryGradientEnd = Color("#0D193E")
  // color: the light 02
  val colorIconFebruaryLight = Color("#B322FF")
  // color: the dark 02
  val colorIconFebruaryDark = Color("#261466")
  // color: the gradient start 02
  val colorIconFebruaryGradientStart = Color("#3E0057")
  // color: the gradient end 02
  val colorIconFebruaryGradientEnd = Color("#3F35D2")
  // color: the light 03
  val colorIconMarchLight = Color("#1A82FF")
  // color: the dark 03
  val colorIconMarchDark = Color("#161466")
  // color: the gradient start 03
  val colorIconMarchGradientStart = Color("#7641F5")
  // color: the gradient end 03
  val colorIconMarchGradientEnd = Color("#870028")
  // color: the light 04
  val colorIconAprilLight = Color("#FF571D")
  // color: the dark 04
  val colorIconAprilDark = Color("#662414")
  // color: the gradient start 04
  val colorIconAprilGradientStart = Color("#C324F5")
  // color: the gradient end 04
  val colorIconAprilGradientEnd = Color("#0098C9")
  // color: the light 05
  val colorIconMayLight = Color("#1DFFFF")
  // color: the dark 05
  val colorIconMayDark = Color("#3E1466")
  // color: the gradient start 05
  val colorIconMayGradientStart = Color("#3C9400")
  // color: the gradient end 05
  val colorIconMayGradientEnd = Color("#FDFF00")
  // color: the light 06
  val colorIconJuneLight = Color("#EAFF1D")
  // color: the dark 06
  val colorIconJuneDark = Color("#661455")
  // color: the gradient start 06
  val colorIconJuneGradientStart = Color("#FF9600")
  // color: the gradient end 06
  val colorIconJuneGradientEnd = Color("#FF14D3")
  // color: the light 07
  val colorIconJulyLight = Color("#1DAEFF")
  // color: the dark 07
  val colorIconJulyDark = Color("#661414")
  // color: the gradient start 07
  val colorIconJulyGradientStart = Color("#E50039")
  // color: the gradient end 07
  val colorIconJulyGradientEnd = Color("#9231F8")
  // color: the light 08
  val colorIconAugustLight = Color("#FFF31D")
  // color: the dark 08
  val colorIconAugustDark = Color("#665A14")
  // color: the gradient start 08
  val colorIconAugustGradientStart = Color("#FFB855")
  // color: the gradient end 08
  val colorIconAugustGradientEnd = Color("#C800E9")
  // color: the light 09
  val colorIconSeptemberLight = Color("#FF6E1D")
  // color: the dark 09
  val colorIconSeptemberDark = Color("#144F66")
  // color: the gradient start 09
  val colorIconSeptemberGradientStart = Color("#FFCE00")
  // color: the gradient end 09
  val colorIconSeptemberGradientEnd = Color("#FF444C")
  // color: the light 10
  val colorIconOctoberLight = Color("#FF881D")
  // color: the dark 10
  val colorIconOctoberDark = Color("#142266")
  // color: the gradient start 10
  val colorIconOctoberGradientStart = Color("#F48FCD")
  // color: the gradient end 10
  val colorIconOctoberGradientEnd = Color("#2431AE")
  // color: the light 11
  val colorIconNovemberLight = Color("#1DFAFF")
  // color: the dark 11
  val colorIconNovemberDark = Color("#3C1466")
  // color: the gradient start 11
  val colorIconNovemberGradientStart = Color("#5B6FA7")
  // color: the gradient end 11
  val colorIconNovemberGradientEnd = Color("#003495")
  // color: the light 12
  val colorIconDecemberLight = Color("#FF1DEA")
  // color: the dark 12
  val colorIconDecemberDark = Color("#141466")
  // color: the gradient start 12
  val colorIconDecemberGradientStart = Color("#2A3EFF")
  // color: the gradient end 12
  val colorIconDecemberGradientEnd = Color("#0DFFF3")
  // color: the base font color
  val colorFontBase = Color("#CCCCCC")
  // color: the 2nd font color
  val colorFontSecondary = Color("#888888")
  // color: the 3rd font color
  val colorFontTertiary = Color("#363636")
}

// size
object MandarinSizes {
  // fontSize: the small size of the font
  val sizeFontSmall = 12.00.px
  // fontSize: the medium size of the font
  val sizeFontMedium = 16.00.px
  // fontSize: the large size of the font
  val sizeFontLarge = 32.00.px
  // fontSize: the base size of the font
  val sizeFontBase = 16.00.px
}
